import script from "./SmallButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallButton.vue?vue&type=script&setup=true&lang=js"

import "./SmallButton.vue?vue&type=style&index=0&id=be67182c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be67182c"]])

export default __exports__